import { __assign, __rest } from "tslib";
import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import { View, Text } from 'react-native';
var PnmacLinearProgress = function (_a) {
  var rest = __rest(_a, []);
  return /*#__PURE__*/React.createElement(LinearProgress, __assign({}, rest));
};
export default PnmacLinearProgress;